import { useAuth } from './store';
import { authManager } from './auth-manager';
import { profileManager } from './profile-manager';
import { permissionManager } from './permission-manager';
import { authMonitor } from './monitoring';
import { supabase } from '../supabase/client';

/**
 * Comprehensive auth system status dashboard
 */
export async function authSystemStatus() {
  console.group('🎯 Auth System Status');
  
  try {
    // 1. Current auth state
    const authState = useAuth.getState();
    console.log('Current State:', {
      user: authState.user?.email || 'None',
      role: authState.user?.role || 'None',
      hasSession: !!authState.session,
      loading: authState.loading,
      error: authState.error
    });
    
    // 3. Supabase session check
    const { data: { session }, error: sessionError } = await supabase.auth.getSession();
    console.log('Supabase Session:', {
      exists: !!session,
      userId: session?.user?.id,
      email: session?.user?.email,
      expiresAt: session?.expires_at ? new Date(session.expires_at * 1000).toLocaleString() : 'N/A',
      error: sessionError?.message
    });
    
    // 4. Performance metrics
    console.log('Performance Metrics:');
    authMonitor.logMetrics();
    
    // 5. Auth system status
    console.log('Auth System Status:', {
      authManager: {
        initialized: authManager.isInitialized(),
        authenticated: authManager.isAuthenticated(),
        loading: authManager.isLoading()
      },
      profileManager: {
        hasProfile: !!(await profileManager.getProfile()).user,
        loading: profileManager.isLoading(),
        cacheStatus: 'Active'
      },
      permissions: {
        role: await permissionManager.getRole(),
        isAdmin: await permissionManager.isAdmin(),
        isCreator: await permissionManager.isCreator()
      }
    });
    
    // 6. Recommendations
    console.log('\n📋 Recommendations:');
    
    if (authState.loading) {
      console.warn('⚠️  Loading is stuck - Run: window.fixAuthLoading()');
    }
    
    if (session && !authState.user) {
      console.warn('⚠️  Session exists but no user profile - Run: window.fixAuthLoading()');
    }
    
    if (!session && authState.user) {
      console.warn('⚠️  User profile exists but no session - Sign out and sign in again');
    }
    
    console.log('✅ Auth system is active');
    
  } catch (error) {
    console.error('Status check error:', error);
  } finally {
    console.groupEnd();
  }
}

// Export to window
if (typeof window !== 'undefined') {
  (window as any).authSystemStatus = authSystemStatus;
} 